import { Icons } from "assets/icons";
import React from "react";

const WeatherCard = ({
  city = "Riyadh",
  temp = 24,
  condition = "Clear",
  high = 28,
  low = 20,
  rain = 0,
  description = "Light winds, low humidity.",
}) => {
  const { weather } = Icons || {};
  return (
    <div className="weather_card">
      <div className="weather_card__content">
        <h3>{city}</h3>

        <h2>
          {temp}°C <span>({condition})</span>
        </h2>

        <p className="weather_card__range">
          H: {high}°C | L: {low}°C | rain: {rain}%
        </p>

        <p className="weather_card__desc">{description}</p>
      </div>
      <img src={weather} alt="weather" width={51} height={51} />
    </div>
  );
};

export default WeatherCard;
